/**
 * OpsPlus Module Routes Configuration
 * Defines all routes for the DevOps monitoring module
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../../../../components/Layout';
import PrivateRoute from '../../../../components/PrivateRoute';

// Pages
import Dashboard from '../pages/Dashboard';
import Projects from '../pages/Projects';
import Alerts from '../pages/Alerts';
import Logs from '../pages/Logs';
import Topology from '../pages/Topology';

/**
 * OpsPlus route configuration
 */
export const opsPlusRoutes: RouteObject[] = [
  {
    path: '/app/opsplus',
    element: <PrivateRoute><Layout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'dashboard',
        element: <Dashboard />
      },
      {
        path: 'projects',
        element: <Projects />
      },
      {
        path: 'alerts',
        element: <Alerts />
      },
      {
        path: 'logs',
        element: <Logs />
      },
      {
        path: 'topology',
        element: <Topology />
      }
    ]
  }
];

export default opsPlusRoutes;
